import {handleActions} from "redux-actions";
import {setReasons} from "../action/reasons";

const initialState = {
    items: [],
    error: null,
    loading: false,
};

const reasons = handleActions(
    {
        [setReasons]: (state, { payload }) => ({
            ...state,
            items: payload,
        }),
        'SET_LOADER': (state, action) => {
            if (action.field === 'reasons') {
                return { ...state, loading: action.value };
            }
            return state;
        },
    },
    initialState
);

export default reasons;